import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputVerteilerKlasse<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: name */
  name?: string;
  /** Alias: hide */
  hide?: boolean;
  /** Alias: personenverteiler */
  personenverteiler?: boolean;
  /** Alias: firmenverteiler */
  firmenverteiler?: boolean;
  /** Alias: pflichtKunden */
  pflichtKunden?: boolean;
  /** Alias: pflichtLieferanten */
  pflichtLieferanten?: boolean;
  /** Alias: sortierung */
  sortierung?: number;
  /** Alias: artikelverteiler */
  artikelverteiler?: boolean;
  /** Alias: maximum */
  maximum?: number;
  /** Alias: kundenverteiler */
  kundenverteiler?: boolean;
  /** Alias: lieferantenverteiler */
  lieferantenverteiler?: boolean;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputVerteilerKlasse> = {
  code: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  hide: {
    alias: 'hide',
  },
  personenverteiler: {
    alias: 'personenverteiler',
  },
  firmenverteiler: {
    alias: 'firmenverteiler',
  },
  pflichtKunden: {
    alias: 'pflichtKunden',
  },
  pflichtLieferanten: {
    alias: 'pflichtLieferanten',
  },
  sortierung: {
    alias: 'sortierung',
  },
  artikelverteiler: {
    alias: 'artikelverteiler',
  },
  maximum: {
    alias: 'maximum',
  },
  kundenverteiler: {
    alias: 'kundenverteiler',
  },
  lieferantenverteiler: {
    alias: 'lieferantenverteiler',
  },
  updateTime: {
    alias: 'updateTime',
  },
  insertTime: {
    alias: 'insertTime',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputVerteilerKlasseEntityDefinition: EntitiyDefinition<InputVerteilerKlasse> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputVerteilerKlasse',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
